







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ItemDaPreVenda } from '@/models/pre-venda/PreVenda'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'

@Component
export default class DialogoDeConferenciaPreVenda extends Vue {
	@Prop({ type: Boolean, default: false }) readonly value!: boolean
	@Prop({ type: Array, default: () => [] }) readonly itens!: ItemDaPreVenda[]

	pesquisa = ''
	mostra = false
	totalConferido: number | null = null

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	headers = [
		{ text: 'Produto', value: 'produto.nome' },
		{ text: 'Sku', value: 'produto.sku' },
		{ text: 'Ean', value: 'produto.eans' },
		{ text: 'Quantidade', value: 'quantidade' },
	]

	async mostrar() {
		this.mostra = true
		this.totalConferido = null
	}

	get itensFiltrados(): ItemDaPreVenda[] {
		if (!this.pesquisa) {
			return this.itens
		}

		const termo = this.pesquisa.toLowerCase()

		return this.itens.filter(item => {
			const nome = item.produto?.nome?.toLowerCase() || ''
			const sku = (item.produto?.sku || '').toString().toLowerCase()
			const eans = Array.isArray(item.produto?.eans)
				? item.produto.eans.join(',').toLowerCase()
				: ''

			return (
				nome.includes(termo) ||
				sku.includes(termo) ||
				eans.includes(termo)
			)
		})
	}

	fechar() {
		this.mostra = false
		this.pesquisa = ''
		this.totalConferido = null
		this.paginacao = {
			page: 1,
			itemsPerPage: 5,
			sortBy: [],
			sortDesc: [],
			groupBy: [],
			groupDesc: [],
			multiSort: false,
			mustSort: false,
		}
	}

	concluirConferencia() {
		const esperado = this.totalOriginal
		const conferido = Number(this.totalConferido ?? 0)

		if (!this.totalConferido && this.totalConferido !== 0) {
			AlertModule.setError('Informe o total conferido antes de concluir a conferência.')
			return
		}

		if (conferido !== esperado) {
			AlertModule.setError(`Total divergente na conferência, valor conferido: ${conferido}.`)
			return
		}

		this.$emit('conferenciaConcluida', this.itens)
		this.fechar()
	}

	get totalFiltrado(): number {
		return this.itensFiltrados.length
	}

	get itensPaginados(): ItemDaPreVenda[] {
		const { page, itemsPerPage } = this.paginacao

		if (itemsPerPage <= 0) {
			return this.itensFiltrados
		}

		const start = (page - 1) * itemsPerPage
		const end = start + itemsPerPage

		return this.itensFiltrados.slice(start, end)
	}

	get totalOriginal(): number {
		return this.itens.reduce((acc, item) => {
			const qtd = item.quantidade || 0
			return acc + qtd
		}, 0)
	}
}
